export default __webpack_public_path__ + "static/media/slide3.efd1ee6f.jpg";